module.exports = __webpack_public_path__ + "media/images/icons/create-event-21519161356a4fcc51ce4ec2c5bf3ded.svg";